<!--begin::Body-->
<div class="kt-login__body">
    <div class="kt-login__form">
        <!-- <kt-auth-notice></kt-auth-notice> -->

        <div class="card shadow">
            <h4 class="align-middle text-center my-3">Parola Sıfırlama</h4>

            <div class="kt-login__divider" style="margin: 0 !important;">
                <div class="kt-divider">
                    <span></span>
                </div>
            </div>
            <form class="card-body" [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
                <div class="row">
                    <div class="form-group col-md-12">
                        <label for="newPassword">Yeni Parola</label>
                        <input
                            id="newPassword"
                            class="form-control"
                            type="password"
                            placeholder="Yeni Parola"
                            aria-placeholder="Yeni Parola"
                            formControlName="newPassword"
                            autocomplete="off"
                            [ngClass]="{
                                'is-invalid': resetPasswordForm.touched && resetPasswordForm.controls.newPassword.errors,
                                'is-valid': resetPasswordForm.touched && !resetPasswordForm.controls.newPassword.errors
                            }"
                        />
                        <div class="invalid-feedback" *ngIf="resetPasswordForm.controls.newPassword.hasError('required')">
                            {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
                        </div>
                        <div class="invalid-feedback" *ngIf="resetPasswordForm.controls.newPassword.hasError('minlength')">
                            {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                            {{ resetPasswordForm.controls.newPassword.errors['minlength'].requiredLength }}
                            {{ 'VALIDATION.ENTERED' | translate }}
                            {{ resetPasswordForm.controls.newPassword.errors['minlength'].actualLength }}
                        </div>
                        <div class="invalid-feedback" *ngIf="resetPasswordForm.controls.newPassword.hasError('maxlength')">
                            {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                            {{ resetPasswordForm.controls.newPassword.errors['maxlength'].requiredLength }}
                            {{ 'VALIDATION.ENTERED' | translate }}
                            {{ resetPasswordForm.controls.newPassword.errors['maxlength'].actualLength }}
                        </div>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="newPasswordRepeat">Yeni Parola (Tekrar)</label>
                        <input
                            id="newPasswordRepeat"
                            class="form-control"
                            type="password"
                            placeholder="Yeni Parola (Tekrar)"
                            aria-placeholder="Yeni Parola (Tekrar)"
                            formControlName="newPasswordRepeat"
                            autocomplete="off"
                            [ngClass]="{
                                'is-invalid': resetPasswordForm.touched && resetPasswordForm.controls.newPasswordRepeat.errors,
                                'is-valid': resetPasswordForm.touched && !resetPasswordForm.controls.newPasswordRepeat.errors
                            }"
                        />
                        <div class="invalid-feedback" *ngIf="resetPasswordForm.controls.newPasswordRepeat.hasError('required')">
                            {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
                        </div>
                        <div class="invalid-feedback" *ngIf="resetPasswordForm.controls.newPasswordRepeat.hasError('minlength')">
                            {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                            {{ resetPasswordForm.controls.newPasswordRepeat.errors['minlength'].requiredLength }}
                            {{ 'VALIDATION.ENTERED' | translate }}
                            {{ resetPasswordForm.controls.newPasswordRepeat.errors['minlength'].actualLength }}
                        </div>
                        <div class="invalid-feedback" *ngIf="resetPasswordForm.controls.newPasswordRepeat.hasError('maxlength')">
                            {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                            {{ resetPasswordForm.controls.newPasswordRepeat.errors['maxlength'].requiredLength }}
                            {{ 'VALIDATION.ENTERED' | translate }}
                            {{ resetPasswordForm.controls.newPasswordRepeat.errors['maxlength'].actualLength }}
                        </div>
                    </div>
                    <div class="col-md-12 text-right">
                        <a class="btn btn-default mr-1" routerLink="/auth/login"> <i class="fa fa-chevron-left"></i> Geri Dön </a>
                        <button type="submit" class="btn btn-primary" [disabled]="resetPasswordForm.invalid">
                            <i class="fa fa-sync"></i> Parola Sıfırla
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
